import React, { useContext, useEffect } from "react";
import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";

const ChannelDetails = () => {
  const [{ channelName, specifiedChannel }, dispatch] =
    useContext(ContextForClient);
  useEffect(() => {
    const url = `onechannel?channel=${channelName}`,
      storage = "specifiedChannel";

    fetchRequest({ url, storage, dispatch });
  }, [channelName, dispatch]);

  const details =
    specifiedChannel && specifiedChannel ? (
      <section className="container mt-5">
        <hr />
        <h4 className="container w-100 text-uppercase text-white">
          {specifiedChannel.name}
        </h4>

        <div className="container w-100" style={{ color: "#aaa" }}>
          <p>{specifiedChannel.description}</p>
        </div>
        <hr />
      </section>
    ) : (
      <div>
        <h2>nothing was found</h2>
      </div>
    );

  return <div>{details}</div>;
};

export default ChannelDetails;
